import { axiosInstance } from "../../../utils";

const actions = {
  CREATE_USER_REQUESTED: "CREATE_USER_REQUESTED",
  CREATE_USER_SUCCEEDED: "CREATE_USER_SUCCEEDED",
  CREATE_USER_FAILED: "CREATE_USER_FAILED",
  CLEAR_USER: "CLEAR_USER",
  BLOCK_USER_REQUESTED: "BLOCK_USER_REQUESTED",
  BLOCK_USER_SUCCEEDED: "BLOCK_USER_SUCCEEDED",
  BLOCK_USER_FAILED: "BLOCK_USER_FAILED",
  UNBLOCK_USER_REQUESTED: "UNBLOCK_USER_REQUESTED",
  UNBLOCK_USER_SUCCEEDED: "UNBLOCK_USER_SUCCEEDED",
  UNBLOCK_USER_FAILED: "UNBLOCK_USER_FAILED",

  addUser: (data = undefined) => {
    return {
      type: actions.CREATE_USER_REQUESTED,
      payload: data,
    };
  },

  addNotes: (data = undefined) => {
    return {
      type: actions.CREATE_USER_REQUESTED,
      payload: data,
    };
  },

  blockUser: (data = undefined) => {
    return {
      type: actions.BLOCK_USER_REQUESTED,
      payload: data,
    };
  },

  unBlockUser: (data = undefined) => {
    return {
      type: actions.UNBLOCK_USER_REQUESTED,
      payload: data,
    };
  },

  clearUser: () => {
    return {
      type: actions.CLEAR_USER,
    };
  },

  createOrUpdateUser: async (data = undefined) => {
    let url = `users/create`;
    let bodyFormData = new FormData();

    if (data._id) {
      url = `users/` + data._id;
    }

    if (data.username !== undefined && data.username !== null)
      bodyFormData.set("username", data.username);
    if (data.email !== undefined && data.email !== null)
      bodyFormData.set("email", data.email);

    if (data.is_vip == true || data.is_vip == false)
      bodyFormData.set("is_vip", data.is_vip);
    if (data.is_active == true || data.is_active == false)
      bodyFormData.set("is_active", data.is_active);
    if (data.is_blocked == true || data.is_blocked == false)
      bodyFormData.set("is_blocked", data.is_blocked);
    if (data.full_name !== undefined && data.full_name !== null)
      bodyFormData.set("full_name", data.full_name);
    if (data.role) bodyFormData.set("role", data.role);
    if (data.notes) bodyFormData.set("notes", data.notes);
    if (data.gender) bodyFormData.set("gender", data.gender);
    if (data.birth_date) bodyFormData.set("birth_date", data.birth_date);
    if (data.description) bodyFormData.set("description", data.description);

    if (data.password) bodyFormData.set("password", data.password);
    if (data.mobile_number)
      bodyFormData.set("mobile_number", data.mobile_number);
    if (data.privileges)
      bodyFormData.set("privileges", JSON.stringify(data.privileges));
    if (data.classifications)
      bodyFormData.set("classifications", JSON.stringify(data.classifications));
    if (data.profile_image) {
      bodyFormData.append("profile_image", data.profile_image);
    }

    if (
      data.can_place_customer_orders === true ||
      data.can_place_customer_orders === false
    )
      bodyFormData.set(
        "can_place_customer_orders",
        data.can_place_customer_orders
      );
    if (
      data.auto_dispatch_enabled === true ||
      data.auto_dispatch_enabled === false
    )
      bodyFormData.set("auto_dispatch_enabled", data.auto_dispatch_enabled);

    if (data.supplier_type === "A" || data.supplier_type === "B")
      bodyFormData.set("supplier_type", data.supplier_type);

    if (data.operating_hours)
      bodyFormData.set("operating_hours", JSON.stringify(data.operating_hours));

    if (data.long !== undefined && data.long !== null && data.long !== "")
      bodyFormData.set("long", data.long);
    if (data.lat !== undefined && data.lat !== null && data.lat !== "")
      bodyFormData.set("lat", data.lat);

    if (data._id) {
      try {
        const user = await axiosInstance.put(url, bodyFormData);
        return user.data;
      } catch (error) {
        throw error;
      }
    } else {
      try {
        const user = await axiosInstance.post(url, bodyFormData);
        return user.data;
      } catch (error) {
        throw error;
      }
    }
  },
};

export default actions;
